import { Button, CircularProgress, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import useWhishList from "../../../Hooks/useWhishList";
import { StyledIconButton } from "../../StyledComponents/StyledButton/StyledButton";

type Props = {
  id: string;
  type: string;
  is_favorite: boolean;
};

const AddToFavoriteButton = ({ id, type, is_favorite }: Props) => {
  const { t } = useTranslation();
  const { handleAddOrRemoveFromFavorite, loading, isFavorite } = useWhishList(
    id,
    type,
    is_favorite
  );

  const matches = useMediaQuery("(max-width:768px)");
  if (matches) {
    return (
      <StyledIconButton
        onClick={handleAddOrRemoveFromFavorite}
        variant="contained"
      >
        {loading ? (
          <CircularProgress size={20} />
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25.541"
            height="23.434"
            viewBox="0 0 25.541 23.434"
          >
            <g
              id="Icon_material-favorite"
              data-name="Icon material-favorite"
              transform="translate(-3 -4.5)"
              fill={isFavorite ? "#a500b9" : "#a47fd1"}
            >
              <path
                d="M 15.77319812774658 26.58415222167969 L 14.59208297729492 25.50892639160156 L 14.57445335388184 25.49293518066406 C 8.206752777099609 19.71873664855957 4.000003337860107 15.90407562255859 4.000003337860107 11.5238561630249 C 4.000003337860107 8.14598560333252 6.645993232727051 5.499995708465576 10.02385330200195 5.499995708465576 C 11.90988349914551 5.499995708465576 13.77359294891357 6.366315841674805 15.00929355621338 7.817405700683594 L 15.77064323425293 8.711465835571289 L 16.5319938659668 7.817405700683594 C 17.76769256591797 6.366315841674805 19.63140296936035 5.499995708465576 21.51743316650391 5.499995708465576 C 24.89529228210449 5.499995708465576 27.54128265380859 8.14598560333252 27.54128265380859 11.5238561630249 C 27.54128265380859 15.89633560180664 23.34781265258789 19.70707511901855 17.00021362304688 25.47534561157227 L 16.94985389709473 25.5211067199707 L 15.77319812774658 26.58415222167969 Z"
                stroke="none"
              />
              <path
                d="M 15.7757453918457 25.23417282104492 L 16.32768249511719 24.73527526855469 C 19.48341369628906 21.8675651550293 22.20879364013672 19.39092636108398 24.0130729675293 17.17933654785156 C 25.76155281066895 15.03613567352295 26.54128265380859 13.29191589355469 26.54128265380859 11.5238561630249 C 26.54128265380859 10.15572547912598 26.02593231201172 8.886905670166016 25.09015274047852 7.951125621795654 C 24.15438270568848 7.015355587005615 22.88556289672852 6.499995708465576 21.51743316650391 6.499995708465576 C 19.92062377929688 6.499995708465576 18.34152412414551 7.234855651855469 17.29334259033203 8.46574592590332 L 15.77064323425293 10.25386619567871 L 14.24794292449951 8.46574592590332 C 13.19976329803467 7.234855651855469 11.6206636428833 6.499995708465576 10.02385330200195 6.499995708465576 C 8.655723571777344 6.499995708465576 7.386903285980225 7.015355587005615 6.451133251190186 7.951125621795654 C 5.515353202819824 8.886905670166016 5.000003337860107 10.15572547912598 5.000003337860107 11.5238561630249 C 5.000003337860107 13.29503536224365 5.782413005828857 15.04204559326172 7.536913394927979 17.18838500976562 C 9.347163200378418 19.40293502807617 12.08085346221924 21.8818359375 15.24619293212891 24.75215530395508 L 15.7757453918457 25.23417282104492 M 15.77064323425293 27.93413543701172 L 13.91890335083008 26.24840545654297 C 7.342023372650146 20.28451538085938 3.000003337860107 16.35115623474121 3.000003337860107 11.5238561630249 C 3.000003337860107 7.590495586395264 6.090493202209473 4.499995708465576 10.02385330200195 4.499995708465576 C 12.24594306945801 4.499995708465576 14.37864303588867 5.534425735473633 15.77064323425293 7.169065952301025 C 17.16264343261719 5.534425735473633 19.29534339904785 4.499995708465576 21.51743316650391 4.499995708465576 C 25.45079231262207 4.499995708465576 28.54128265380859 7.590495586395264 28.54128265380859 11.5238561630249 C 28.54128265380859 16.35115623474121 24.19927406311035 20.28451538085938 17.62238311767578 26.26117515563965 L 15.77064323425293 27.93413543701172 Z"
                stroke="none"
                fill="#e8d6ff"
              />
            </g>
          </svg>
        )}
      </StyledIconButton>
    );
  }
  return (
    <Button
      onClick={handleAddOrRemoveFromFavorite}
      variant="contained"
      sx={{
        fontSize: {
          mobile: "16px",
          lg: "20px",
        },
        background: "#CEAFF5",
        color: "white",
        width: {
          mobile: "150px",
          sm: "200px",
          lg: "240px",
        },
        height: {
          mobile: "50px",
          md: "60px",
          lg: "75px",
        },
        fontWeight: "600 !important",
        borderRadius: "10px",
      }}
      startIcon={
        loading ? (
          <CircularProgress size={20} />
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25.541"
            height="23.434"
            viewBox="0 0 25.541 23.434"
          >
            <g
              id="Icon_material-favorite"
              data-name="Icon material-favorite"
              transform="translate(-3 -4.5)"
              fill={isFavorite ? "#a500b9" : "#a47fd1"}
            >
              <path
                d="M 15.77319812774658 26.58415222167969 L 14.59208297729492 25.50892639160156 L 14.57445335388184 25.49293518066406 C 8.206752777099609 19.71873664855957 4.000003337860107 15.90407562255859 4.000003337860107 11.5238561630249 C 4.000003337860107 8.14598560333252 6.645993232727051 5.499995708465576 10.02385330200195 5.499995708465576 C 11.90988349914551 5.499995708465576 13.77359294891357 6.366315841674805 15.00929355621338 7.817405700683594 L 15.77064323425293 8.711465835571289 L 16.5319938659668 7.817405700683594 C 17.76769256591797 6.366315841674805 19.63140296936035 5.499995708465576 21.51743316650391 5.499995708465576 C 24.89529228210449 5.499995708465576 27.54128265380859 8.14598560333252 27.54128265380859 11.5238561630249 C 27.54128265380859 15.89633560180664 23.34781265258789 19.70707511901855 17.00021362304688 25.47534561157227 L 16.94985389709473 25.5211067199707 L 15.77319812774658 26.58415222167969 Z"
                stroke="none"
              />
              <path
                d="M 15.7757453918457 25.23417282104492 L 16.32768249511719 24.73527526855469 C 19.48341369628906 21.8675651550293 22.20879364013672 19.39092636108398 24.0130729675293 17.17933654785156 C 25.76155281066895 15.03613567352295 26.54128265380859 13.29191589355469 26.54128265380859 11.5238561630249 C 26.54128265380859 10.15572547912598 26.02593231201172 8.886905670166016 25.09015274047852 7.951125621795654 C 24.15438270568848 7.015355587005615 22.88556289672852 6.499995708465576 21.51743316650391 6.499995708465576 C 19.92062377929688 6.499995708465576 18.34152412414551 7.234855651855469 17.29334259033203 8.46574592590332 L 15.77064323425293 10.25386619567871 L 14.24794292449951 8.46574592590332 C 13.19976329803467 7.234855651855469 11.6206636428833 6.499995708465576 10.02385330200195 6.499995708465576 C 8.655723571777344 6.499995708465576 7.386903285980225 7.015355587005615 6.451133251190186 7.951125621795654 C 5.515353202819824 8.886905670166016 5.000003337860107 10.15572547912598 5.000003337860107 11.5238561630249 C 5.000003337860107 13.29503536224365 5.782413005828857 15.04204559326172 7.536913394927979 17.18838500976562 C 9.347163200378418 19.40293502807617 12.08085346221924 21.8818359375 15.24619293212891 24.75215530395508 L 15.7757453918457 25.23417282104492 M 15.77064323425293 27.93413543701172 L 13.91890335083008 26.24840545654297 C 7.342023372650146 20.28451538085938 3.000003337860107 16.35115623474121 3.000003337860107 11.5238561630249 C 3.000003337860107 7.590495586395264 6.090493202209473 4.499995708465576 10.02385330200195 4.499995708465576 C 12.24594306945801 4.499995708465576 14.37864303588867 5.534425735473633 15.77064323425293 7.169065952301025 C 17.16264343261719 5.534425735473633 19.29534339904785 4.499995708465576 21.51743316650391 4.499995708465576 C 25.45079231262207 4.499995708465576 28.54128265380859 7.590495586395264 28.54128265380859 11.5238561630249 C 28.54128265380859 16.35115623474121 24.19927406311035 20.28451538085938 17.62238311767578 26.26117515563965 L 15.77064323425293 27.93413543701172 Z"
                stroke="none"
                fill="#e8d6ff"
              />
            </g>
          </svg>
        )
      }
      disableElevation
      disabled={loading}
    >
      {t("addToFavorite")}
    </Button>
  );
};

export default AddToFavoriteButton;
